import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Table } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';

const ShowPetition = () => {
  const navigate = useNavigate();
  const [news, setNews] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/petitions/list`
        );

        const petitionid = window.location.href.split('/').pop();
        if (petitionid) {
          setNews(
            response.data.filter((item) => item.petitionId === petitionid)[0]
          );
        } else {
          navigate('/petitions/list');
        }
      } catch (error) {
        // console.log('error', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const prettyDate = (zuluDate) => {
    const date = new Date(zuluDate);

    const formattedDate = `${date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })} ${date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })}`;

    return formattedDate;
  };

  return (
    <>
      <PageHeader
        title='Petitions List'
        description=''
        className='mb-3'
      ></PageHeader>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error}</div>
      ) : news ? (
        <Table hover responsive>
          <tbody>
            <tr>
              <td>Petition ID: {news.petitionId}</td>
            </tr>
            <tr>
              <td>Status: {news.status}</td>
            </tr>
            <tr>
              <td>
                Date Submitted: {prettyDate(news.dateSentToPetitionsUnit)}
              </td>
            </tr>
            <tr>
              <td>Department: {news.department}</td>
            </tr>
            <tr>
              <td>Title: {news.petitionTitle}</td>
            </tr>
            <tr>
              <td>Petitioner: {news.fullName}</td>
            </tr>
            <tr>
              <td>Address: {news.address}</td>
            </tr>
            <tr>
              <td>District: {news.district}</td>
            </tr>
            <tr>
              <td>Organisation: {news.orgName}</td>
            </tr>
            <tr>
              <td>Email: {news.email}</td>
            </tr>
            <tr>
              <td>Phone Number 1: {news.phoneNumber1}</td>
            </tr>
            <tr>
              <td>Phone Number 2: {news.phoneNumber2}</td>
            </tr>
            <tr>
              <td>Fax Number: {news.faxNumber}</td>
            </tr>
            <tr>
              <td>
                Petition Details:{' '}
                <div
                  dangerouslySetInnerHTML={{ __html: news.petitionDetails }}
                />
              </td>
            </tr>
          </tbody>
        </Table>
      ) : (
        <div>Petition not found</div>
      )}
    </>
  );
};

export default ShowPetition;
